import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactSelect from 'react-select'
import { t } from '../../../i18n'
import Modal from '../shared/Modal'
import CustomButton from '../shared/CustomButton'
import InvoiceProductFormContainer from './InvoiceProductFormContainer'
import Moment from 'moment'

class InvoiceItem extends Component {
  state = {
    createModal: false,
    editHeaderModal: false,
    removeModal: false,
    product: null,
    // Header edit form values — populated when the modal opens
    editNumber: '',
    editDate: '',
    editSaleType: null,
  }

  showCreationModal   = () => this.setState({ createModal: true })
  showRemoveModal     = (product) => this.setState({ removeModal: true, product })
  showEditHeaderModal = () => {
    const { invoice, saleTypes } = this.props
    this.setState({
      editHeaderModal: true,
      editNumber: invoice.invoice_number || '',
      editDate: invoice.invoice_date ? invoice.invoice_date.slice(0, 10) : '',
      editSaleType: saleTypes.find(function(s) { return s.name === invoice.sale_type }) || null,
    })
  }
  untoggling = (name) => () => this.setState({ [name]: false, product: null })

  handleProductCreation = (data) => {
    this.props.onProductCreation(data)
    this.setState({ createModal: false })
  }

  handleProductRemove = () => {
    this.props.onProductRemove(this.state.product)
    this.setState({ removeModal: false, product: null })
  }

  handleHeaderSave = () => {
    const { editNumber, editDate, editSaleType } = this.state
    this.props.onHeaderEdit({ number: editNumber, invoiceDate: editDate, saleType: editSaleType, document: {} })
    this.setState({ editHeaderModal: false })
  }

  render() {
    const { campaign, linking, editable, invoice, products, saleTypes, headerErrors } = this.props
    const { createModal, editHeaderModal, removeModal, editNumber, editDate, editSaleType } = this.state

    return (
      <div className="invoice-form-page">
        <Link className="invoice-form-back" to={linking}>← Voltar</Link>
        <h1 className="invoice-form-title">Fatura</h1>

        {/* ── Header card ── */}
        <div className="invoice-form-card">
          <div className="invoice-form-row">
            <div className="invoice-form-field">
              <span className="invoice-form-label">Nº Fatura</span>
              <span>{invoice.invoice_number || '-'}</span>
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Tipo de Venda</span>
              <span>{invoice.sale_type || '-'}</span>
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Data</span>
              <span>{invoice.invoice_date ? new Moment(invoice.invoice_date).format(t('date-format')) : '-'}</span>
            </div>
          </div>
          {invoice.attachment && (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a className="gl-button secondary medium body-m" href={invoice.attachment.url} target="_blank" rel="noopener noreferrer" download>
              Download Anexo
            </a>
          )}
          {editable && (
            <button className="gl-button secondary medium body-m" type="button" onClick={this.showEditHeaderModal}>
              Editar cabeçalho
            </button>
          )}
        </div>

        {/* ── Products card ── */}
        <div className="invoice-form-card">
          <div className="invoice-form-section-title">Produtos</div>
          {products.length > 0 && (
            <div className="invoice-form-products-list">
              {products.map(function(p, i) {
                return (
                  <div key={'prod-' + i} className="invoice-form-product-row">
                    <span className="invoice-form-product-cell">{p.product && p.product.external_identifier}</span>
                    <span className="invoice-form-product-cell">Qtd: {p.quantity}</span>
                    {editable && (
                      <button type="button" className="invoice-form-product-remove" onClick={function() { this.showRemoveModal(p) }.bind(this)}>×</button>
                    )}
                  </div>
                )
              }.bind(this))}
            </div>
          )}
          {editable && (
            <button className="gl-button secondary medium body-m" type="button" onClick={this.showCreationModal}>
              Adicionar Produto
            </button>
          )}
        </div>

        {/* ── Submit to validation ── */}
        {editable && products.length > 0 && (
          <div className="invoice-form-actions">
            <button className="gl-button primary medium body-m" type="button" onClick={this.props.onSubmitToValidation}>
              Enviar para aprovação
            </button>
          </div>
        )}

        {/* ── Add product modal ── */}
        {editable && (
          <Modal large untoggle={this.untoggling('createModal')} show={createModal}>
            <InvoiceProductFormContainer createMode onCancel={this.untoggling('createModal')} onSubmit={this.handleProductCreation} campaign={campaign} />
          </Modal>
        )}

        {/* ── Remove product confirm modal ── */}
        {editable && (
          <Modal small untoggle={this.untoggling('removeModal')} show={removeModal}>
            <div className="gl2026-modal__header">
              <h4 className="gl2026-modal__title">Remover produto?</h4>
            </div>
            <div className="gl2026-modal__footer">
              <CustomButton secondary type="button" onClick={this.untoggling('removeModal')}>Não</CustomButton>
              <CustomButton type="button" onClick={this.handleProductRemove}>Sim</CustomButton>
            </div>
          </Modal>
        )}

        {/* ── Edit header modal ── */}
        {editable && (
          <Modal untoggle={this.untoggling('editHeaderModal')} show={editHeaderModal}>
            <div className="gl2026-modal__header">
              <h4 className="gl2026-modal__title">Editar Cabeçalho</h4>
              <button className="gl2026-modal__close" type="button" onClick={this.untoggling('editHeaderModal')}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12" /></svg>
              </button>
            </div>
            <div className="invoice-product-form">
              <div className="invoice-product-form-grid">
                <div className="invoice-product-form-field">
                  <label className="invoice-form-label">Nº Fatura</label>
                  <input className="invoice-form-input" value={editNumber} onChange={function(e) { this.setState({ editNumber: e.target.value }) }.bind(this)} />
                </div>
                <div className="invoice-product-form-field">
                  <label className="invoice-form-label">Data</label>
                  <input type="date" className="invoice-form-input" value={editDate} onChange={function(e) { this.setState({ editDate: e.target.value }) }.bind(this)} />
                </div>
                <div className="invoice-product-form-field">
                  <label className="invoice-form-label">Tipo de Venda</label>
                  <ReactSelect
                    options={saleTypes}
                    value={editSaleType}
                    onChange={function(st) { this.setState({ editSaleType: st }) }.bind(this)}
                    getOptionLabel={function(o) { return o.name }}
                    getOptionValue={function(o) { return o.id }}
                    placeholder="Selecione"
                    classNamePrefix="invoice-select"
                  />
                </div>
              </div>
              {headerErrors && Object.keys(headerErrors).length > 0 && (
                <div className="gl2026-modal__alert">Erro ao guardar alterações.</div>
              )}
            </div>
            <div className="invoice-product-form-footer">
              <button className="gl-button secondary medium body-m" type="button" onClick={this.untoggling('editHeaderModal')}>Cancelar</button>
              <button className="gl-button primary medium body-m" type="button" onClick={this.handleHeaderSave}>Guardar</button>
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

export default InvoiceItem
